var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.36,14.95l1.34-1.34,.29-.71V7.1l-.29-.71L13.61,2.29l-.71-.29H7.1l-.71,.29L2.29,6.39l-.29,.71v5.8l.29,.71,4.1,4.1,.71,.29h5.8l.71-.29,1.34-1.34,5.34,5.34,1.41-1.41-5.34-5.34Zm-.36-2.46l-3.51,3.51H7.51l-3.51-3.51V7.51l3.51-3.51h4.97l3.51,3.51v4.97Zm-9-3.49h6v2H7v-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchMinus);
export default __webpack_public_path__ + "static/1776335122/media/icon-search-minus.d8cb88d06fdfd07c39fea9960a0afc59.svg";
export { ForwardRef as ReactComponent };